import { ApplePaySettings, ApplePayPaymentRequest } from '../..';

export class ApplePayPaymentRequestBuilder {
	private applePayPaymentRequest: ApplePayJSV14.ApplePayPaymentRequest;

	constructor(private applePaySettings: ApplePaySettings) {
		this.applePayPaymentRequest = new ApplePayPaymentRequest();
	}

	setTotal(total: ApplePayJSV14.ApplePayLineItem): this {
		this.applePayPaymentRequest.total = total;
		return this;
	}

	setCountryCode(): this {
		this.applePayPaymentRequest.countryCode = this.applePaySettings.countryCode ?? 'US';
		return this;
	}

	setCurrencyCode(): this {
		this.applePayPaymentRequest.currencyCode = this.applePaySettings.currencyCode ?? 'USD';
		return this;
	}

	setMerchantCapabilites(): this {
		let merchantCapabilities: ApplePayJS.ApplePayMerchantCapability[] = ['supports3DS']; // required
		if (this.applePaySettings.acceptsCredit) {
			merchantCapabilities.push('supportsCredit');
		}
		if (this.applePaySettings.acceptsDebit) {
			merchantCapabilities.push('supportsDebit');
		}

		this.applePayPaymentRequest.merchantCapabilities = merchantCapabilities;
		return this;
	}

	setSupportedNetworks(): this {
		this.applePayPaymentRequest.supportedNetworks = this.applePaySettings.supportedNetworks;
		return this;
	}

	setRequiredBillingContactFields(requiredFields?: ApplePayJS.ApplePayContactField[]): this {
		this.applePayPaymentRequest.requiredBillingContactFields = requiredFields ?? [
			'name',
			'postalAddress'
		];
		return this;
	}

	setRecurringPaymentRequest(recurringAmount: string): this {
		const applePayRecurringRequest: ApplePayJSV14.ApplePayRecurringPaymentRequest = {
			paymentDescription: this.applePaySettings.paymentDescription,
			regularBilling: this.getRegularBilling(recurringAmount),
			billingAgreement: this.applePaySettings.billingAgreement,
			managementURL: this.applePaySettings.mangementURL
		};

		this.applePayPaymentRequest.recurringPaymentRequest = applePayRecurringRequest;
		return this;
	}

	private getRegularBilling(recurringAmount: string): ApplePayJSV14.ApplePayLineItem {
		const regularBilling: ApplePayJSV14.ApplePayLineItem = {
			label: this.applePaySettings.recurringLabel,
			amount: recurringAmount ?? '0',
			paymentTiming: this.applePaySettings.paymentTiming,
			recurringPaymentStartDate: this.applePaySettings.recurringPaymentStartDate,
			recurringPaymentIntervalUnit: this.applePaySettings.recurringPaymentIntervalUnit,
			recurringPaymentIntervalCount: this.applePaySettings.recurringPaymentIntervalCount,
		};

		if (this.applePaySettings.recurringPaymentEndDate) {
			regularBilling.recurringPaymentEndDate = this.applePaySettings.recurringPaymentEndDate;
		}

		return regularBilling;
	}

	getApplePayPaymentRequest(): ApplePayJSV14.ApplePayPaymentRequest {
		return this.applePayPaymentRequest;
	}
}
